import script from "./AdminUserProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUserProfileView.vue?vue&type=script&setup=true&lang=js"

import "./AdminUserProfileView.vue?vue&type=style&index=0&id=0a720894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a720894"]])

export default __exports__